import {
  combineTranslationBundles,
  loadPackageTranslations,
  Localization,
  setupTranslationLanguageSync,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import {reportFiltersWidgetTranslations} from '@widgets/report-filters'
import i18n from 'i18next'

const supportedLngs: LanguageCode[] = ['en-US', 'pl-PL', 'ru-RU']

const isDevelopment = process.env.NODE_ENV === 'development'

const loader = async (filename: string) => {
  if (isDevelopment) {
    console.info(`Load translation for refractory planner app [${filename}]`)
  }

  try {
    return (await import(`./translations/${filename}/${filename}`)).default
  } catch (err) {
    if (isDevelopment) {
      console.error(`Could not load translation for refractory planner app [${filename}]`, err)
    }
    return {err}
  }
}

const externalPackageTranslations = combineTranslationBundles([
  uikitTranslations,
  reportFiltersWidgetTranslations
])

export const initLocalization = () => {
  void Localization({
    supportedLngs,
    backend: {loader},
    debug: isDevelopment,
    fallbackLng: 'en-US',
    compatibilityJSON: undefined,
    load: 'currentOnly'
  }).then(() => {
    void loadPackageTranslations(i18n, externalPackageTranslations, {debug: isDevelopment})
    setupTranslationLanguageSync(i18n, externalPackageTranslations, {debug: isDevelopment})
  })
}
